import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

const heroImages = [
  { img: '/tshirt_ragazzo.png', label: 'Lui' },
  { img: '/tshirt_ragazza.png', label: 'Lei' },
  { img: '/tshirt_gruppo.png', label: 'La Crew' },
];

const generationNames = ['Gen Z', 'Millennials', 'Gen X', 'Alpha', 'Beta'];

const Lightbox = ({ src, alt, onClose }) => (
  <div className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4 cursor-zoom-out" onClick={onClose}>
    <img src={src} alt={alt} className="max-w-full max-h-full object-contain" />
    <button onClick={onClose} className="absolute top-6 right-6 text-white/60 hover:text-white text-3xl font-mono">X</button>
  </div>
);

const ZoomableImg = ({ src, alt, className }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <img src={src} alt={alt} className={`${className} cursor-zoom-in hover:scale-105 transition-transform`} onClick={() => setOpen(true)} />
      {open && <Lightbox src={src} alt={alt} onClose={() => setOpen(false)} />}
    </>
  );
};

const TshirtGalleryPage = () => {
  const [slide, setSlide] = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  const goTo = useCallback((idx) => {
    if (transitioning) return;
    setTransitioning(true);
    setSlide(idx);
    setTimeout(() => setTransitioning(false), 600);
  }, [transitioning]);

  useEffect(() => {
    const t = setInterval(() => goTo((slide + 1) % heroImages.length), 5000);
    return () => clearInterval(t);
  }, [slide, goTo]);

  const tiers = [
    { amount: '1€', belt: 'Cintura Bianca', color: '#FFFFFF', reward: 'Badge Digitale' },
    { amount: '5€', belt: 'Cintura Arancione', color: '#F97316', reward: 'Penna Total Black' },
    { amount: '10€', belt: 'Cintura Verde', color: '#22C55E', reward: 'Supporto Bambu' },
    { amount: '15€', belt: 'Cintura Blu', color: '#3B82F6', reward: 'T-shirt </GEN...' },
    { amount: '19€', belt: 'Cintura Marrone', color: '#92400E', reward: 'T-shirt + Penna' },
  ];

  const premiumRewards = [
    { img: '/cintura_pelle.png', belt: 'Cintura Rossa', amount: '50€', reward: 'Cintura in Vera Pelle', desc: 'Cintura in vera pelle con logo AI_covo.tech impresso', border: 'border-red-600' },
    { img: '/cover_bundle.png', belt: 'Gran Maestro', amount: '100€+', reward: 'Cover Tablet + Smartphone + T-shirt + Penna', desc: 'Bundle completo esclusivo', border: 'border-amber-500' },
  ];

  return (
    <main data-testid="tshirt-page" className="pt-20 pb-16">
      <div className="max-w-6xl mx-auto px-6">

        {/* HERO */}
        <div className="text-center mb-8">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-3">Linea esclusiva</p>
          <h1 className="text-4xl md:text-6xl font-black text-white mb-1">
            T-Shirt <span className="text-[#00FF41] font-mono">&lt;/</span>GEN...
          </h1>
          <p className="text-zinc-500 text-sm font-mono">Total Black — Stile All Blacks — Solo per soci</p>
        </div>

        {/* AI Image Gallery con overlay branding */}
        <div className="max-w-2xl mx-auto mb-10" data-testid="tshirt-hero-gallery">
          <div className="bg-[#0A0A0A] border-2 border-[#00FF41]/30 rounded-2xl overflow-hidden">
            <div className="relative aspect-[4/5] md:aspect-[5/5] bg-black overflow-hidden">
              {heroImages.map((photo, idx) => (
                <div
                  key={idx}
                  className="absolute inset-0 transition-all duration-700 ease-in-out"
                  style={{
                    opacity: slide === idx ? 1 : 0,
                    transform: slide === idx ? 'scale(1)' : 'scale(1.05)',
                  }}
                >
                  <img
                    src={photo.img}
                    alt={`T-Shirt </GEN... — ${photo.label}`}
                    className="w-full h-full object-cover"
                    loading={idx === 0 ? 'eager' : 'lazy'}
                  />
                  {/* Gradient overlay per leggibilità */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20" />

                  {/* Logo </AI_covo.tech>® + genZ — sul petto */}
                  <div className="absolute bottom-[18%] left-[15%] z-20 flex flex-col items-start pointer-events-none">
                    <span className="font-mono font-black text-base sm:text-lg md:text-2xl" style={{
                      color: '#00FF41',
                      WebkitTextStroke: '1px rgba(0,0,0,0.9)',
                      paintOrder: 'stroke fill',
                      textShadow: '0 0 14px rgba(0,255,65,0.6), 0 0 30px rgba(0,255,65,0.2)',
                      filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.8))',
                    }}>&lt;/AI_covo.tech&gt;<sup style={{ fontSize: '0.45em', verticalAlign: 'super', fontFamily: 'Georgia, serif', fontWeight: 400 }}>&reg;</sup></span>
                    <span className="font-mono text-[6px] sm:text-[7px] md:text-[8px] text-white/60 tracking-[0.15em] mt-0" style={{ textShadow: '0 1px 4px rgba(0,0,0,0.9)' }}>DIGITAL HUB SOCIALE</span>
                    <span className="font-black text-2xl sm:text-3xl md:text-4xl text-white -mt-1" style={{
                      WebkitTextStroke: '1.5px rgba(0,0,0,0.9)',
                      paintOrder: 'stroke fill',
                      textShadow: '0 0 8px rgba(255,255,255,0.15), 0 2px 6px rgba(0,0,0,0.7)',
                      fontFamily: "'Arial Black', sans-serif",
                      letterSpacing: '0.08em',
                    }}>genZ</span>
                  </div>

                  {/* Label badge */}
                  <div className="absolute top-4 left-4">
                    <span className="inline-block px-3 py-1 rounded-full bg-black/50 backdrop-blur-md border border-[#00FF41]/30 font-mono text-[10px] text-[#00FF41] tracking-wider">{photo.label}</span>
                  </div>
                </div>
              ))}

              {/* Dots */}
              <div className="absolute bottom-4 left-0 right-0 flex justify-center z-10">
                <div className="flex items-center gap-3 bg-black/60 backdrop-blur-md px-4 py-2 rounded-full border border-white/10">
                  {heroImages.map((_, idx) => (
                    <button
                      key={idx}
                      data-testid={`hero-slide-${idx}`}
                      onClick={() => goTo(idx)}
                      className={`transition-all duration-300 rounded-full ${slide === idx ? 'w-8 h-2 bg-[#00FF41]' : 'w-2 h-2 bg-white/30 hover:bg-white/60'}`}
                    />
                  ))}
                </div>
              </div>

              {/* Arrows */}
              <button onClick={() => goTo((slide - 1 + heroImages.length) % heroImages.length)} className="absolute left-3 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-black/50 backdrop-blur border border-white/10 text-white/70 hover:text-[#00FF41] transition-all">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M15 18l-6-6 6-6"/></svg>
              </button>
              <button onClick={() => goTo((slide + 1) % heroImages.length)} className="absolute right-3 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-black/50 backdrop-blur border border-white/10 text-white/70 hover:text-[#00FF41] transition-all">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M9 18l6-6-6-6"/></svg>
              </button>
            </div>

            {/* Info */}
            <div className="p-5 text-center border-t border-white/5">
              <h3 className="font-black text-white text-lg mb-1">T-Shirt &lt;/AI_covo.tech&gt;® genZ</h3>
              <p className="text-zinc-500 text-xs">Logo <span className="text-[#00FF41] font-mono">&lt;/AI_covo.tech&gt;®</span> sul cuore + <strong className="text-white">genZ</strong> sul petto</p>
              <p className="text-zinc-600 text-[10px] mt-2 font-mono">Da Cintura Blu (15€) in su</p>
            </div>
          </div>
        </div>

        {/* Generazioni — chi la indossa */}
        <div className="text-center mb-10">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-3">Una maglia per ogni generazione</p>
          <div className="flex flex-wrap justify-center gap-3">
            {generationNames.map((g, i) => (
              <span key={i} className="inline-block px-4 py-2 rounded-full border border-[#00FF41]/30 bg-[#00FF41]/5 font-mono text-sm text-white hover:bg-[#00FF41]/15 transition-colors cursor-default">
                {g}
              </span>
            ))}
          </div>
        </div>

        {/* NON IN VENDITA banner */}
        <div className="bg-[#FF6B35]/5 border border-[#FF6B35]/30 p-6 text-center mb-14 rounded-lg">
          <p className="text-[#FF6B35] font-black text-lg mb-1" data-testid="tshirt-non-vendita">NON IN VENDITA</p>
          <p className="text-zinc-400 text-sm">Il merchandising <span className="text-[#00FF41] font-mono font-bold">&lt;/AI_covo.tech&gt;®</span> non si compra. Si <strong className="text-white">sblocca</strong> con la tua donazione.</p>
        </div>

        {/* Tiers */}
        <div className="text-center mb-8">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-3">Scegli la tua cintura</p>
          <h2 className="text-3xl md:text-4xl font-black text-white">
            La tua cintura, <span className="text-[#00FF41]">il tuo premio.</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mb-14">
          {tiers.map((t, i) => (
            <div key={i} data-testid={`tier-${i}`} className="bg-[#0A0A0A] border border-zinc-800 rounded-lg p-5 text-center hover:border-[#00FF41]/40 transition-all">
              <div className="w-10 h-10 rounded-full mx-auto mb-3 border-2" style={{ borderColor: t.color, backgroundColor: `${t.color}15` }}>
                <div className="w-full h-full flex items-center justify-center">
                  <span className="text-[#00FF41] font-mono font-bold text-sm">&lt;/</span>
                </div>
              </div>
              <p className="text-2xl font-black mb-1" style={{ color: t.color }}>{t.amount}</p>
              <p className="text-zinc-400 text-xs font-mono mb-1">{t.belt}</p>
              <p className="text-zinc-600 text-[11px]">{t.reward}</p>
            </div>
          ))}
        </div>

        {/* Premium */}
        <div className="mb-6 text-center">
          <p className="font-mono text-xs text-[#00FF41] uppercase tracking-wider mb-4">Premi Esclusivi</p>
        </div>
        <div className="grid md:grid-cols-2 gap-6 mb-14">
          {premiumRewards.map((p, i) => (
            <div key={i} data-testid={`premium-${i}`} className={`bg-gradient-to-br from-zinc-900 to-zinc-800 border-2 ${p.border} p-6 text-center rounded-lg relative overflow-hidden`}>
              <ZoomableImg src={p.img} alt={p.reward} className="w-full h-48 object-contain mb-4" />
              <p className="text-2xl font-black text-[#00FF41] mb-1">{p.amount}</p>
              <p className="text-lg font-bold text-white mb-1">{p.reward}</p>
              <p className="text-zinc-400 text-sm mb-2">{p.desc}</p>
              <p className="text-zinc-500 text-xs font-mono">{p.belt}</p>
            </div>
          ))}
        </div>

        {/* Come funziona */}
        <div className="bg-[#0A0A0A] border border-white/10 p-8 mb-12 rounded-lg">
          <h2 className="text-2xl font-bold text-white mb-6 text-center">Come funziona</h2>
          <div className="grid md:grid-cols-3 gap-6">
            {[
              { n: '1', title: 'Scegli la tua cintura', desc: 'Dona l\'importo corrispondente al livello desiderato' },
              { n: '2', title: 'Scegli il tuo nome', desc: 'Nome, nickname o soprannome - tu decidi' },
              { n: '3', title: 'Ricevi il tuo premio', desc: 'T-shirt (fino a 19€) o premio esclusivo (oltre 19€)' },
            ].map((s, i) => (
              <div key={i} className="text-center">
                <div className="w-12 h-12 bg-[#00FF41]/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-[#00FF41] font-bold text-xl">{s.n}</span>
                </div>
                <h3 className="text-white font-bold mb-2">{s.title}</h3>
                <p className="text-zinc-500 text-sm">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="text-xl text-white font-bold mb-6">Tu, che cintura vuoi essere?</p>
          <Link to="/dona" data-testid="tshirt-cta-dona" className="inline-block bg-[#00FF41] text-black font-black px-12 py-4 text-lg hover:bg-[#33FF66] transition-colors rounded">
            Scegli la tua cintura
          </Link>
        </div>
      </div>
    </main>
  );
};

export default TshirtGalleryPage;
